import { useState } from "react";
import { useAppSelector } from "redux-share/hooks";
import { ConditionName, ICopyTextProps } from "interfaces";
import { conditions, videoTag } from "helpers";
import { sendFluentLog, shareCopyLog } from "../../../../../logs";
import CopyIcon from "../../icon-components/copy";
import { shallowEqual } from "react-redux";

const CopyText = ({ link, markerId, videoTime, isJump }: ICopyTextProps): JSX.Element => {
    const [isCopy, setIsCopy] = useState<boolean | undefined>(undefined);
    const [buttonClassNames, setButtonClassNames] = useState<string>("");
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { params, details, videoElementSizeInfo } }) => ({ params, details, videoElementSizeInfo }), shallowEqual);

    const handleCopy = (event: any) => {
        event.preventDefault();
        setButtonClassNames("animate");
        setTimeout(() => setButtonClassNames(""), 2000);
        if (conditions(ConditionName.hasClipboard)) {
            sendFluentLog(shareCopyLog(Number(videoTag().currentTime.toFixed(0)), isJump, videoTime, markerId));
            navigator.clipboard.writeText(link!);
            setIsCopy(true);
            setTimeout(() => setIsCopy(false), 2000);
        }
    };

    return (
        <button
            className={`pl-confetti-button ${buttonClassNames} ${
                !isCopy && "active:pl-scale-75"
            } pl-flex pl-flex-1 pl-items-center pl-justify-center pl-gap-2 pl-py-[11px] pl-bg-secondary-200 dark:pl-bg-dark-1 pl-rounded-[8px] ${
                isCopy ? "pl-cursor-default" : "pl-cursor-pointer"
            }`}
            onClick={!isCopy ? handleCopy : () => {}}
        >
            <CopyIcon className="stroke-z-secondary-600 dark:stroke-secondary-50" />
            <div className="pl-flex pl-items-center pl-justify-center pl-mr-10 pl-text-secondary-500 dark:pl-text-secondary-50">
                <span
                    className={`pl-absolute animate__animated pl-text-secondary-500 dark:pl-text-secondary-50 ${
                        isCopy === true && "animate__fadeOutDown"
                    } ${isCopy === false && "animate__fadeInUp"}`}
                    style={{ left: conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? 60 : "unset" }}
                >
                    کپی لینک
                </span>
                <span
                    className={`pl-absolute animate__animated pl-opacity-0 pl-transition-opacity pl-duration-300 pl-text-secondary-500 dark:pl-text-secondary-50 ${
                        isCopy === true && "animate__fadeInUp pl-opacity-100"
                    }`}
                    style={{ left: conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? 60 : "unset" }}
                >
                    لینک کپی شد
                </span>
            </div>
        </button>
    );
};

export default CopyText;
